import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {increaseQty, decreaseQty , addToCart} from "../features/cart/cartSlice";


function FoodDetail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);
  //console.log(cartItems);

  const food = useSelector((state) =>
    state.food.items.find((item) => item.id === Number(id))
  );

  const getQuantity = (id) => {
  const item = cartItems.find((i) => i.id === id);
  return item ? item.quantity : 0;
};

  if (!food) return <h2>Food not found</h2>;

  return (
    <div className="container-fluid home-container-banner vh-100">
        <div className="container pt-4">
            <div className="row mt-4">
                <div className="col-md-6">
                    <img src={food.image} style={{ width: "450px" }} alt="food" />
                </div>
                <div className="col-md-5">
                    <h2>{food.name}</h2>
                    <p>{food.tags}</p>
                    <p>{food.ingredients}</p>
                    <h3><b>₹ {food.caloriesPerServing}</b></h3>
                    <p>Rating: {food.rating}</p>
                    <div className="d-flex">
                        <button
                            className="btn btn-dark"
                            onClick={() => {
                            console.log(food);
                            dispatch(addToCart(food));
                            }}
                        >
                            Add to Cart
                        </button>

                        <div className="d-flex justify-content-between align-items-center  mx-2">
                            <button className="btn btn-primary" disabled={getQuantity(food.id) === 0} onClick={() => dispatch(decreaseQty(food.id))}>-</button>
                            <span className="p-2">{getQuantity(food.id)}</span>
                            <button className="btn btn-primary" onClick={() => dispatch(increaseQty(food))}>+</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default FoodDetail;